import { render, staticRenderFns } from "./InsightsPage.vue?vue&type=template&id=561e5a62"
import script from "./InsightsPage.vue?vue&type=script&lang=js"
export * from "./InsightsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports